import React from "react";
//@dependencies
import classNames from "classnames";
import PropTypes from "prop-types";
// MUI
import { Button, CircularProgress } from "@mui/material";
//styles
import styles from "./CustomButton.module.scss";

const CustomButton = React.forwardRef((props, ref) => {
  const {
    color,
    round,
    children,
    fullWidth,
    disabled,
    simple,
    size,
    block,
    link,
    justIcon,
    className,
    muiClasses,
    loading,
    ...rest
  } = props;

  const btnClasses = classNames({
    [styles.button]: true,
    [styles[size]]: size,
    [styles[color]]: color,
    [styles.round]: round,
    [styles.fullWidth]: fullWidth,
    [styles.disabled]: disabled,
    [styles.simple]: simple,
    [styles.block]: block,
    [styles.link]: link,
    [styles.justIcon]: justIcon,
    [className]: className,
  });

  return (
    <Button
      {...rest}
      ref={ref}
      disabled={disabled}
      classes={muiClasses}
      className={btnClasses}
    >
      {loading ? <CircularProgress size={24} color={"inherit"} /> : children}
    </Button>
  );
});

//types
CustomButton.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "white",
    "transparent",
  ]),
  size: PropTypes.oneOf(["sm", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object,
  loading: PropTypes.bool,
  children: PropTypes.node,
};

export default CustomButton;
